import React from 'react';
import QRCode from 'react-qr-code';
import styled from '@emotion/styled';
import PaymentStatus from '~Components/PaymentStatus';
import { POSPayment } from '~reducers';

const Container = styled.div`
  animation: fadeInSlideIn 500ms ease-in-out;
  width: 100%;
  max-width: 48rem;

  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;

  @keyframes fadeInSlideIn {
    0% {
      opacity: 0;
      transform: translateY(32px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Card = styled.div`
  margin-top: 150px;
  border-radius: 0.5rem;
  background: var(--card);
  color: var(--card-foreground);
  overflow: hidden;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
`;

const CardContent = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

const QRContainer = styled.div`
  background: white;
  padding: 1rem;
  border-radius: 0.5rem;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
`;

interface Props {
  payment: POSPayment;
}

export const QRCodeDisplay: React.FC<Props> = ({ payment }) => {
  return (
    <Container>
      <Card>
        <CardContent>
          <QRContainer>
            {payment.meta?.qr && <QRCode value={payment.meta.qr} size={128} />}
          </QRContainer>

          <PaymentStatus paymentId={payment.id} status={payment.status} onlyShowStatus />
        </CardContent>
      </Card>
    </Container>
  );
};
